(() => {
  if (window.PHFBookingLoaded) return;
  window.PHFBookingLoaded = true;

  const SELECTORS = {
    root: '[data-phf-booking]',
    card: '[data-phf-card]',
    toggle: '[data-phf-toggle]',
    body: '[data-phf-card-body]',
    chev: '[data-phf-chev]',
    pick: '[data-phf-pick]',
    overlay: '[data-phf-overlay]',
    close: '[data-phf-close]',
    sidebar: '[data-phf-sidebar]',
    subtitle: '[data-phf-subtitle]',
    iframe: '[data-phf-iframe]'
  };

  function setCardOpen(card, isOpen) {
    const toggle = card.querySelector(SELECTORS.toggle);
    const body = card.querySelector(SELECTORS.body);
    const chev = card.querySelector(SELECTORS.chev);

    card.classList.toggle('phf-card--open', isOpen);
    toggle?.setAttribute('aria-expanded', String(isOpen));

    if (body) body.hidden = !isOpen;
    if (chev) chev.textContent = isOpen ? '−' : '+';
  }

  function closeOtherCards(root, activeCard) {
    root.querySelectorAll(SELECTORS.card).forEach((card) => {
      if (card !== activeCard) setCardOpen(card, false);
    });
  }

  function createText(tag, className, text) {
    if (!text) return null;

    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;

    return element;
  }

  function decodeHtmlEntities(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function normaliseBookingUrl(rawValue) {
    if (!rawValue) return '';

    let value = decodeHtmlEntities(String(rawValue)).trim();

    const iframeMatch = value.match(
      /<iframe[^>]*\ssrc\s*=\s*(['"])(.*?)\1/i
    );

    if (iframeMatch?.[2]) {
      value = iframeMatch[2].trim();
    }

    if (value.startsWith('//')) {
      value = `https:${value}`;
    }

    if (!/^https?:\/\//i.test(value)) {
      return '';
    }

    try {
      const parsedUrl = new URL(value);

      return ['http:', 'https:'].includes(parsedUrl.protocol)
        ? parsedUrl.href
        : '';
    } catch (error) {
      return '';
    }
  }

  function buildSidebar(root, button) {
    const sidebar = root.querySelector(SELECTORS.sidebar);

    if (!sidebar) return;

    sidebar.replaceChildren();

    const clinicName =
      root.dataset.clinicName || 'Perth Health & Fertility';

    const practitionerName =
      button.dataset.phfPractitionerName || '';

    const practitionerRole =
      button.dataset.phfPractitionerRole || '';

    const practitionerImage =
      button.dataset.phfPractitionerImage || '';

    const fallbackText =
      button.dataset.phfFallbackText || '';

    const avatarBg =
      button.dataset.phfAvatarBg || '#E4ECF6';

    const avatarFg =
      button.dataset.phfAvatarFg || '#3E6EA8';

    const consultationName =
      button.dataset.phfConsultationName || '';

    const duration =
      button.dataset.phfDuration || '';

    const price =
      button.dataset.phfPrice || '';

    const description =
      button.dataset.phfDescription || '';

    const mode =
      button.dataset.phfMode || '';

    /*
     * ============================================
     * YOUR APPOINTMENT
     * ============================================
     */

    const eyebrow = createText(
      'p',
      'phf-cal-sidebar__eyebrow',
      'Your appointment'
    );

    if (eyebrow) {
      sidebar.appendChild(eyebrow);
    }

    /*
     * ============================================
     * PRACTITIONER
     * ============================================
     */

    const person = document.createElement('div');
    person.className = 'phf-cal-sidebar__person';

    const avatar = document.createElement('span');
    avatar.className = 'phf-cal-sidebar__avatar';

    avatar.style.setProperty(
      '--phf-avatar-bg',
      avatarBg
    );

    avatar.style.setProperty(
      '--phf-avatar-fg',
      avatarFg
    );

    if (practitionerImage) {
      const image = document.createElement('img');

      image.className =
        'phf-cal-sidebar__avatar-image';

      image.src = practitionerImage;
      image.alt = practitionerName;
      image.loading = 'lazy';

      avatar.appendChild(image);
    } else {
      const fallback =
        document.createElement('span');

      fallback.className =
        'phf-cal-sidebar__avatar-fallback';

      fallback.textContent = fallbackText;

      avatar.appendChild(fallback);
    }

    person.appendChild(avatar);

    const personText =
      document.createElement('div');

    const practitioner = createText(
      'div',
      'phf-cal-sidebar__practitioner',
      practitionerName
    );

    const role = createText(
      'div',
      'phf-cal-sidebar__clinic',
      practitionerRole
    );

    const clinic = createText(
      'div',
      'phf-cal-sidebar__clinic',
      clinicName
    );

    if (practitioner) {
      personText.appendChild(practitioner);
    }

    if (role) {
      personText.appendChild(role);
    }

    if (clinic) {
      personText.appendChild(clinic);
    }

    person.appendChild(personText);

    sidebar.appendChild(person);

    /*
     * ============================================
     * APPOINTMENT DETAILS
     * ============================================
     */

    const details =
      document.createElement('div');

    details.className =
      'phf-cal-sidebar__details';

    /*
     * Consultation
     */

    const consultationGroup =
      document.createElement('div');

    const consultationLabel = createText(
      'div',
      'phf-cal-sidebar__label',
      'Consultation'
    );

    const consultationValue = createText(
      'div',
      'phf-cal-sidebar__value',
      consultationName
    );

    if (consultationLabel) {
      consultationGroup.appendChild(
        consultationLabel
      );
    }

    if (consultationValue) {
      consultationGroup.appendChild(
        consultationValue
      );
    }

    details.appendChild(
      consultationGroup
    );

    /*
     * Length + Fee
     */

    const facts =
      document.createElement('div');

    facts.className =
      'phf-cal-sidebar__facts';

    if (duration) {
      const group =
        document.createElement('div');

      const label = createText(
        'div',
        'phf-cal-sidebar__label',
        'Length'
      );

      const value = createText(
        'div',
        'phf-cal-sidebar__value',
        duration
      );

      if (label) {
        group.appendChild(label);
      }

      if (value) {
        group.appendChild(value);
      }

      facts.appendChild(group);
    }

    if (price) {
      const group =
        document.createElement('div');

      const label = createText(
        'div',
        'phf-cal-sidebar__label',
        'Fee'
      );

      const value = createText(
        'div',
        'phf-cal-sidebar__value',
        price
      );

      if (label) {
        group.appendChild(label);
      }

      if (value) {
        group.appendChild(value);
      }

      facts.appendChild(group);
    }

    if (facts.children.length) {
      details.appendChild(facts);
    }

    /*
     * Format
     */

    if (mode) {
      const modeGroup =
        document.createElement('div');

      const modeLabel = createText(
        'div',
        'phf-cal-sidebar__label',
        'Format'
      );

      const modeValue = createText(
        'span',
        'phf-cal-sidebar__format',
        mode
      );

      if (modeLabel) {
        modeGroup.appendChild(
          modeLabel
        );
      }

      if (modeValue) {
        modeGroup.appendChild(
          modeValue
        );
      }

      details.appendChild(
        modeGroup
      );
    }

    /*
     * ============================================
     * WHAT'S INCLUDED
     *
     * IMPORTANT CHANGE:
     *
     * Earlier:
     * description was inserted using textContent.
     *
     * That caused HTML like:
     *
     * <p>
     * <ul>
     * <li>
     *
     * to display as plain text.
     *
     * Now:
     * innerHTML is used.
     *
     * So HTML formatting works correctly.
     * ============================================
     */

    if (description) {
      const descriptionGroup =
        document.createElement('div');

      descriptionGroup.className =
        'phf-cal-sidebar__description';

      /*
       * Heading
       */

      const descriptionLabel =
        createText(
          'div',
          'phf-cal-sidebar__label',
          "What's included"
        );

      /*
       * HTML content wrapper
       *
       * NOTE:
       * This is DIV instead of P because
       * you may have paragraphs, lists,
       * headings etc. inside it.
       */

      const descriptionContent =
        document.createElement('div');

      descriptionContent.className =
        'phf-cal-sidebar__description-text';

      /*
       * Render HTML properly.
       *
       * Supports:
       *
       * <p>
       * <ul>
       * <ol>
       * <li>
       * <h2>
       * <h3>
       * <h4>
       * <strong>
       * <b>
       * <em>
       * <i>
       * <br>
       * <a>
       * etc.
       */

      descriptionContent.innerHTML =
        decodeHtmlEntities(description);

      if (descriptionLabel) {
        descriptionGroup.appendChild(
          descriptionLabel
        );
      }

      descriptionGroup.appendChild(
        descriptionContent
      );

      details.appendChild(
        descriptionGroup
      );
    }

    sidebar.appendChild(details);
  }

  /*
   * ============================================
   * INITIALISE SECTION
   * ============================================
   */

  function initSection(root) {
    if (
      !root ||
      root.dataset.phfInit === '1'
    ) {
      return;
    }

    root.dataset.phfInit = '1';

    const overlay =
      root.querySelector(
        SELECTORS.overlay
      );

    const closeButton =
      root.querySelector(
        SELECTORS.close
      );

    const iframe =
      root.querySelector(
        SELECTORS.iframe
      );

    const subtitle =
      root.querySelector(
        SELECTORS.subtitle
      );

    let lastFocusedElement = null;
    let resetTimer = null;

    /*
     * ============================================
     * SHOW / HIDE MODAL
     * ============================================
     */

    function showOverlay(show) {
      if (!overlay) return;

      overlay.classList.toggle(
        'phf-cal-overlay--open',
        show
      );

      overlay.setAttribute(
        'aria-hidden',
        show ? 'false' : 'true'
      );

      document.documentElement.classList.toggle(
        'phf-booking-modal-open',
        show
      );

      document.body.classList.toggle(
        'phf-booking-modal-open',
        show
      );

      /*
       * Reset iframe after modal closes.
       */

      if (!show && iframe) {
        resetTimer =
          window.setTimeout(() => {
            iframe.src =
              'about:blank';

            iframe.setAttribute(
              'aria-busy',
              'false'
            );
          }, 200);
      }
    }

    /*
     * ============================================
     * OPEN BOOKING
     * ============================================
     */

    function openBooking(button) {
      if (!overlay || !iframe) {
        return;
      }

      const url =
        normaliseBookingUrl(
          button.dataset
            .phfBookingUrl || ''
        );

      if (!url) {
        console.warn(
          '[PHF booking] Missing or invalid Practice Master iframe URL.',
          {
            practitioner:
              button.dataset
                .phfPractitionerName ||
              '',

            consultation:
              button.dataset
                .phfConsultationName ||
              '',

            mode:
              button.dataset
                .phfMode ||
              ''
          }
        );

        return;
      }

      /*
       * Clear old reset timer.
       */

      if (resetTimer) {
        window.clearTimeout(
          resetTimer
        );

        resetTimer = null;
      }

      lastFocusedElement =
        button;

      /*
       * Build sidebar data.
       */

      buildSidebar(
        root,
        button
      );

      const practitionerName =
        button.dataset
          .phfPractitionerName ||
        '';

      const consultationName =
        button.dataset
          .phfConsultationName ||
        '';

      const timezoneText =
        root.dataset
          .timezoneText ||
        '';

      /*
       * Subtitle
       */

      if (subtitle) {
        subtitle.textContent =
          [
            practitionerName
              ? `Live availability for ${practitionerName} from our clinic calendar.`
              : 'Live availability from our clinic calendar.',

            timezoneText
          ]
            .filter(Boolean)
            .join(' ');
      }

      /*
       * Iframe title
       */

      iframe.title =
        [
          consultationName,

          practitionerName
            ? `with ${practitionerName}`
            : '',

          'booking'
        ]
          .filter(Boolean)
          .join(' ');

      iframe.setAttribute(
        'aria-busy',
        'true'
      );

      iframe.src = url;

      showOverlay(true);

      /*
       * Focus close button.
       */

      window.requestAnimationFrame(
        () => {
          closeButton?.focus();
        }
      );
    }

    /*
     * ============================================
     * CLOSE BOOKING
     * ============================================
     */

    function closeBooking() {
      showOverlay(false);

      if (
        lastFocusedElement
        instanceof HTMLElement
      ) {
        lastFocusedElement.focus();
      }
    }

    /*
     * ============================================
     * ROOT CLICK EVENTS
     * ============================================
     */

    root.addEventListener(
      'click',
      (event) => {
        const target =
          event.target;

        if (
          !(target instanceof Element)
        ) {
          return;
        }

        /*
         * Accordion toggle
         */

        const toggle =
          target.closest(
            SELECTORS.toggle
          );

        if (
          toggle &&
          root.contains(toggle)
        ) {
          const card =
            toggle.closest(
              SELECTORS.card
            );

          if (!card) {
            return;
          }

          const shouldOpen =
            !card.classList.contains(
              'phf-card--open'
            );

          if (shouldOpen) {
            closeOtherCards(
              root,
              card
            );
          }

          setCardOpen(
            card,
            shouldOpen
          );

          return;
        }

        /*
         * Appointment button
         */

        const pickButton =
          target.closest(
            SELECTORS.pick
          );

        if (
          pickButton &&
          root.contains(
            pickButton
          )
        ) {
          if (
            pickButton.disabled ||
            pickButton.getAttribute(
              'aria-disabled'
            ) === 'true'
          ) {
            return;
          }

          openBooking(
            pickButton
          );

          return;
        }

        /*
         * Close button
         */

        const close =
          target.closest(
            SELECTORS.close
          );

        if (
          close &&
          root.contains(close)
        ) {
          closeBooking();
        }
      }
    );

    /*
     * ============================================
     * CLICK BACKDROP TO CLOSE
     * ============================================
     */

    overlay?.addEventListener(
      'click',
      (event) => {
        if (
          event.target === overlay
        ) {
          closeBooking();
        }
      }
    );

    /*
     * ============================================
     * IFRAME LOADED
     * ============================================
     */

    iframe?.addEventListener(
      'load',
      () => {
        iframe.setAttribute(
          'aria-busy',
          'false'
        );
      }
    );

    /*
     * ============================================
     * ESC KEY
     * ============================================
     */

    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape' &&
          overlay?.classList.contains(
            'phf-cal-overlay--open'
          )
        ) {
          closeBooking();
        }
      }
    );

    /*
     * ============================================
     * SHOPIFY THEME EDITOR
     * ============================================
     */

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const blockId =
          event.detail?.blockId;

        if (!blockId) {
          return;
        }

        const card =
          root.querySelector(
            `[data-block-id="${blockId}"]`
          );

        if (!card) {
          return;
        }

        closeOtherCards(
          root,
          card
        );

        setCardOpen(
          card,
          true
        );

        card.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    );

    /*
     * Initial state.
     */

    showOverlay(false);
  }

  /*
   * ============================================
   * BOOT
   * ============================================
   */

  function boot(
    scope = document
  ) {
    if (!scope) {
      return;
    }

    if (
      scope instanceof Element &&
      scope.matches(
        SELECTORS.root
      )
    ) {
      initSection(scope);
    }

    scope
      .querySelectorAll?.(
        SELECTORS.root
      )
      .forEach(
        initSection
      );
  }

  /*
   * DOM ready.
   */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => boot()
    );
  } else {
    boot();
  }

  /*
   * Shopify section reload.
   */

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      boot(event.target)
  );
})();